<template>
  <layout-main-inner title="报名管理">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <status-select v-model="config.status" />
        <el-input
          v-model="config.idName"
          style="margin-left: 10px;width: 240px;"
          clearable
          placeholder="请输入姓名"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="姓名"
          min-width="140"
          prop="idName"></el-table-column>
        <el-table-column
          label="手机号"
          min-width="100"
          prop="mobile">
        </el-table-column>
        <el-table-column
          label="原证书编号"
          min-width="180"
          prop="originalCertNo">
        </el-table-column>
        <el-table-column
          label="原证书图片"
          width="100">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.originalCertFile"
              fit="cover"
              style="width:60px; height: 60px;display: block;"
              :src="row.originalCertFile"
              :preview-src-list="[row.originalCertFile]"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="报名类型"
          min-width="100">
          <template slot-scope="{ row }">{{ row.type === 1 ? '继续教育' : '能力升级' }}</template>
        </el-table-column>
        <el-table-column
          label="拟报名申请等级"
          min-width="110">
          <template slot-scope="{ row }">{{ row.level | levelName() }}</template>
        </el-table-column>
        <el-table-column
          label="联系状态"
          min-width="80">
          <template slot-scope="{ row }">{{ row.status === 0 ? '未联系' : '已联系' }}</template>
        </el-table-column>
        <el-table-column
          label="申请时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="90">
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.status === 1"
              type="text"
              @click="updateitem(row)">设为已联系</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import StatusSelect from './busi/status-select.vue'
const levelMap = { 2: '中级', 3: '高级' }
export default {
  name: 'LuxuryRenewalCert',
  components: { StatusSelect },
  filters: {
    levelName(val) {
      return levelMap[val]
    }
  },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, idName: '', status: null }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      console.log(row)
      this.$confirm('您确定将此报名信息设置为已联系?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$CommonApi.updateluxurycertrenewal({ id: row.id, status: 1 })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('设置成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$CommonApi.getluxurycertrenewals({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, records, total, message } = res.data
          if ([0].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
